import styled from 'styled-components';
import {
  ITEM_ALIGN_TOP,
  ITEM_ALIGN_CENTER,
  ITEM_ALIGN_BOTTOM,
  ITEM_TYPE_CHECKBOX,
  ITEM_TYPE_RADIO,
} from './ListItem.constants';

const themes = {
  1: {
    descriptionColor: 'var(--color-grey-11_60)',
  },
};

const sizes = {
  s: {
    titleFontSize: '13px',
    descriptionFontSize: '11px',
    subTitleFontSize: '11px',
    gap: '8px',
  },
  m: {
    titleFontSize: '15px',
    descriptionFontSize: '13px',
    subTitleFontSize: '13px',
    gap: '8px',
  },
  l: {
    titleFontSize: '17px',
    descriptionFontSize: '15px',
    subTitleFontSize: '15px',
    gap: '12px',
  },
  xl: {
    titleFontSize: '20px',
    descriptionFontSize: '17px',
    subTitleFontSize: '17px',
    gap: '12px',
  },
};

export const Container = styled.div`
  --description-color: ${(p) => themes[p.theme].descriptionColor};
  --gap-size: ${(p) => sizes[p.size].gap};
  --title-font-size: ${(p) => sizes[p.size].titleFontSize};
  --description-font-size: ${(p) => sizes[p.size].descriptionFontSize};
  --subtitle-font-size: ${(p) => sizes[p.size].subTitleFontSize};
  --align-items: ${(p) => {
    switch (p.align) {
      case ITEM_ALIGN_TOP:
        return 'start';
      case ITEM_ALIGN_CENTER:
        return 'center';
      case ITEM_ALIGN_BOTTOM:
        return 'end';
      default:
        return 'center';
    }
  }};

  display: flex;
  justify-content: space-between;
  align-items: var(--align-items);
  cursor: ${(p) =>
    [ITEM_TYPE_CHECKBOX, ITEM_TYPE_RADIO].includes(p.type) ? 'pointer' : 'default'};
`;

export const MainContent = styled.div`
  display: flex;
  align-items: var(--align-items);
`;

export const LeftSlot = styled.div`
  margin-right: var(--gap-size);
`;

export const ContentSlot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-size: var(--title-font-size);
`;

export const Description = styled.span`
  font-size: var(--description-font-size);
  color: var(--description-color);
`;

export const SubTitle = styled.span`
  font-size: var(--subtitle-font-size);
  color: var(--description-color);
`;

export const RightSlot = styled.div`
  display: flex;
  align-items: var(--align-items);
`;
